<template>
  <div class="doctor-card-appointment d-flex flex-column ga-3">
    <template v-if="showAppointmentBlock">
      <LpuNotWorkingLabel
        v-if="isExpressClosed"
        :lpu-working-text="lpuNotWorkingText"
      />

      <div
        class="doctor-card-appointment__schedule"
        :style="{ minHeight: `${SCHEDULE_CALENDAR_MIN_HEIGHT_PX}px` }"
      >
        <DoctorCardCalendar
          v-if="showCalendar"
          :day-items="dayItems"
          :active-date="activeDate"
          :active-day-slots="activeDaySlots"
          :is-disabled="isExpressAppointment && placeType !== 'telemed'"
          @select-day="emit('select-day', $event)"
          @slot="emit('slot', $event)"
        />
        <ScheduleCalendarSkeleton v-else-if="isCardSlotsLoading" />
        <DoctorAppointmentStub v-else-if="showAppointmentStub" />
      </div>

      <template v-if="placeType === 'home'">
        <v-btn
          v-if="showHomeCallButton"
          depressed
          color="primary"
          height="52"
          :href="`tel:${lpuPhoneHref}`"
          :block="isMobile"
          class="branding-btn branding-btn--primary rounded-20 text-none text-subtitle-1"
          data-qa="lpu_doctors_list_home_call"
        >
          <span class="ui-icon-car-clinic mr-2" />
          {{ homeCallLabel }}
        </v-btn>
        <div
          v-if="isMobile"
          class="text-body-2 text-secondary--text"
        >
          {{ tStatic('Стоимость выезда врача к вам домой определяется удаленностью от клиники') }}.
          {{ tStatic('Уточняйте цену у администратора клиники') }}.
        </div>
      </template>

      <v-btn
        v-if="showClinicCallButton"
        depressed
        color="primary"
        height="52"
        :href="`tel:${lpuPhoneHref}`"
        :block="isMobile"
        class="branding-btn branding-btn--primary rounded-20 text-none text-subtitle-1"
        data-qa="appointment-button-lpu-call"
        data-google-goal="appointment_button_lpu_call"
      >
        <span class="ui-icon-phone-none bg-gray-0--text mr-2" />
        {{ tStatic('Позвонить в клинику') }}
      </v-btn>
    </template>

    <div
      v-if="isStaff && !isMobile && (doctor.last_relevance || (showAppointmentBlock && staffAppointmentType))"
      class="d-flex flex-column ga-1"
    >
      <div
        v-if="doctor.last_relevance"
        class="staff-appointment-type ma-0"
      >
        <div class="staff-appointment-type__text">
          {{ tStatic('Актуально') }} {{ doctor.last_relevance }}
        </div>
      </div>
      <div
        v-if="showAppointmentBlock && staffAppointmentType"
        class="staff-appointment-type ma-0"
      >
        <div class="staff-appointment-type__text">
          {{ staffAppointmentType }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import useIsMobile from 'src/composables/useIsMobile'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import LpuNotWorkingLabel from 'src/components/common/LpuNotWorkingLabel/LpuNotWorkingLabel.vue'
import DoctorCardCalendar from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/components/DoctorCardCalendar.vue'
import DoctorAppointmentStub from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/components/DoctorAppointmentStub.vue'
import ScheduleCalendarSkeleton from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuScheduleCalendar/ScheduleCalendarSkeleton.vue'
import { SCHEDULE_CALENDAR_MIN_HEIGHT_PX } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuScheduleCalendar/constants/scheduleCalendarMinHeight'
import type {
  AppointmentPlaceType,
  LpuDoctor,
} from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/types'
import type {
  ScheduleDayItem,
  ScheduleSlot,
} from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuScheduleCalendar/types'

type Emits = {
  (_event: 'select-day', _date: string): void
  (_event: 'slot', _time: string): void
}

defineProps<{
  doctor: LpuDoctor
  lpuPhoneHref: string
  lpuNotWorkingText: string
  homeCallLabel: string
  staffAppointmentType: string
  placeType: AppointmentPlaceType
  dayItems: ScheduleDayItem[]
  activeDate?: string
  activeDaySlots: ScheduleSlot[]
  showAppointmentBlock: boolean
  showCalendar: boolean
  showAppointmentStub: boolean
  showHomeCallButton: boolean
  showClinicCallButton: boolean
  isCardSlotsLoading: boolean
  isExpressAppointment: boolean
  isExpressClosed: boolean
  isStaff: boolean
}>()

const emit = defineEmits<Emits>()
const isMobile = useIsMobile()
</script>
